<template>
  <div class="row">
    <div class="col-6">
      <SelectPortal
        v-model="dadosSelecionados.portais"
        :multiple="true"
        :titulo="'Portais'"
        :required="requiredportal"
        :options="options"
        :isinvalidportal="isinvalidportal"
        @input="atualizarEmpresas"
      />
    </div>
    <div class="col-6">
      <SelectEmpresas
        v-model="dadosSelecionados.empresas"
        :multiple="true"
        :titulo="'Empresas'"
        :required="requiredempresa"
        :options="optionsEmpresas"
        :isinvalidempresa="isinvalidempresa"
      />
    </div>
  </div>
</template>

<script>
import SelectPortal from "../components/SelectPortal.vue";
import SelectEmpresas from "../components/SelectEmpresas.vue";

export default {
  name: "PortalEmpresas",
  props: ["options", "isinvalidempresa", "isinvalidportal", "requiredempresa", "requiredportal"],
  components: {
    SelectPortal,
    SelectEmpresas
  },
  data() {
    return {
      dadosSelecionados: {
        portais: [],
        empresas: []
      },
      optionsEmpresas: []
    };
  },
  watch: {
    "dadosSelecionados.empresas": function() {
      this.$emit("input", this.dadosSelecionados);
    },
    "dadosSelecionados.portais": function() {
      this.$emit("input", this.dadosSelecionados);
    }
  },
  methods: {
    atualizarEmpresas(e) {
      var portais = e.map(x => x.Id);

      this.optionsEmpresas = this.options.filter(portal =>
        portais.includes(portal.Id)
      );
    }
  }
};
</script>